var _path, _path2, _g, _path3, _path4, _g2, _g3, _path5, _path6, _path7, _path8, _path9, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmergencyfundGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEA80",
    d: "M140.46,61.36l0.16-0.05c0-16.74-12.56-35.76-42.14-35.76c-0.98,0-1.9,0.03-2.78,0.07l-1.97-0.54c0,0-5.66-1.46-13.73-1.46s-13.73,1.46-13.73,1.46l-1.97,0.54c-0.88-0.05-1.8-0.07-2.78-0.07c-29.58,0-42.14,19.02-42.14,35.76l0.16,0.05c-1.35,4.48-1.88,8.93-1.88,13c11.48-11.48,25.08,1.02,36.56,12.5c11.48-11.48,40.08-11.48,51.56,0c11.48-11.48,25.08-23.98,36.56-12.5C142.33,70.29,141.8,65.84,140.46,61.36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M51.27,116.11c0,7.93,6.43,14.36,14.36,14.36S80,124.04,80,116.11c0,0,0-37.04,0-37.04"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M80,32.54c0,0-1.09-2.61-6.96-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "19.5672,4.5155",
    d: "M67.03,28.98c-3.19,0.19-7.15,0.78-12.06,1.99c-3.32,0.81-6.36,1.79-9.14,2.91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "12.0414,6.0207,19.5672,4.5155",
    d: "M43.75,34.75c-14.2,6.33-21.22,16.42-24.21,26.36c-0.28,0.95-0.53,1.89-0.75,2.83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.35,66.15c-0.48,2.74-0.69,5.43-0.69,7.96"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD500",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M66.26,25.52c-1.43-0.14-3-0.21-4.74-0.21c-29.58,0-42.14,19.02-42.14,35.76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M80,32.54c-0.64-1.18-2.65-5.95-13.74-7.02"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M80,32.54c0,0,1.09-2.61,6.96-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "19.5672,4.5155",
    d: "M92.97,28.98c3.19,0.19,7.15,0.78,12.06,1.99c3.32,0.81,6.36,1.79,9.14,2.91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "12.0414,6.0207,19.5672,4.5155",
    d: "M116.25,34.75c14.2,6.33,21.22,16.42,24.21,26.36c0.28,0.95,0.53,1.89,0.75,2.83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M141.65,66.15c0.48,2.74,0.69,5.43,0.69,7.96"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD500",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M93.74,25.52c1.43-0.14,3-0.21,4.74-0.21c29.58,0,42.14,19.02,42.14,35.76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M80,32.54c0.64-1.18,2.65-5.95,13.74-7.02"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "5,6,32",
    d: "M106.01,86.61C106.01,23.89,80,32.39,80,32.39s-26.01-8.49-26.01,54.23"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD500",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M17.67,74.11c11.48-11.48,25.08,1.02,36.56,12.5c11.48-11.48,40.08-11.48,51.56,0c11.48-11.48,25.08-23.98,36.56-12.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD500",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M66.27,25.5c0,0,5.66-1.46,13.73-1.46s13.73,1.46,13.73,1.46"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD500",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M140.46,61.11c1.35,4.48,1.88,8.93,1.88,13"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M80,22.61c0,0,0,9.17,0,9.17"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00AAFF",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    d: "M125.93,0v30.08c22.31-22.31,28.32,8.68,29,19.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00AAFF",
    d: "M157.03,54.82c0,1.16-0.94,2.1-2.1,2.1c-1.16,0-2.1-0.94-2.1-2.1s2.1-3.89,2.1-3.89S157.03,53.66,157.03,54.82z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyfundGoal);
export default __webpack_public_path__ + "static/media/emergencyfund-goal.16304773.svg";
export { ForwardRef as ReactComponent };